import {
  Home, Key, Utensils, Briefcase, Flag, Sparkles,
  CheckCircle, Clock, Search, DollarSign,
} from "lucide-react";

export const PHONE = "(239) 244-1934";
export const PHONE_LINK = "tel:+12392441934";
export const isSpanishPath = (pathname) => pathname === "/es" || pathname.startsWith("/es/");
export const EMAIL = "info@cindyrellaclean.com";
export const FACEBOOK_URL = "https://www.facebook.com/CindyrellaClean";
export const INSTAGRAM_URL = "https://www.instagram.com/cindyrella_cleaning";
export const GOOGLE_REVIEW_URL = "https://g.page/r/CYcOfksyTnomEBM/review";

export const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/22fc09d6-5993-494e-9284-a3e876c7697a/images/1db0729cebaeacb15e867c4d4f904445d08eac0a3e720414c78c841802532681.png";

export const FONT_HEAD = "Montserrat, sans-serif";
export const FONT_BODY = "Open Sans, sans-serif";
export const NAVY = "#1B3A6B";
export const GOLD = "#D4A843";

export const SERVICES = [
  {
    id: "residential",
    Icon: Home,
    title: "Residential Homes",
    link: "/services/house-cleaning-naples-fl",
    description:
      "Regular & deep cleaning tailored to your home. We treat every space with care and precision.",
    longDescription:
      "Your home deserves more than a quick wipe-down. Our residential cleaning service is built around your lifestyle — whether you need weekly upkeep, bi-weekly maintenance, or a one-time deep clean. We use professional-grade products and a detailed checklist so nothing gets missed, from baseboards to ceiling fans.",
    included: [
      "Kitchens: counters, appliances, sinks & cabinet fronts",
      "Bathrooms: sanitized showers, tubs, toilets & mirrors",
      "Bedrooms & living areas: dusting, vacuuming, mopping",
      "Baseboards, window sills, light switches & door frames",
      "Deep cleaning & move-in / move-out options",
    ],
    image:
      "https://images.unsplash.com/photo-1649083048770-82e8ffd80431?crop=entropy&cs=srgb&fm=webp&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzc1OTIwOTI5fDA&ixlib=rb-4.1.0&q=70&w=1200",
  },
  {
    id: "housekeeping",
    Icon: Sparkles,
    title: "Housekeeping",
    link: "/services/housekeeping-naples-fl",
    description:
      "Weekly, bi-weekly or monthly housekeeping with a photo report after every visit — your home cared for on a regular schedule.",
    longDescription:
      "Coming home to a clean, organized house shouldn't take your whole weekend. Our housekeeping service cares for your Naples home on a regular schedule — weekly, bi-weekly or monthly — with the same trusted team whenever possible and a photo report after every visit.",
    included: [
      "Dusting of furniture, shelves, baseboards, ceiling fans and light fixtures",
      "Kitchen: countertops, sink, stovetop, exterior of appliances and cabinets",
      "Bathrooms: toilets, showers, tubs, sinks, mirrors and floors sanitized",
      "Vacuuming and mopping of all floors, making beds",
      "Emptying trash and tidying living areas",
    ],
    image:
      "https://images.unsplash.com/photo-1683629357846-30eacff8f615?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxzcG90bGVzcyUyMGx1eHVyeSUyMGtpdGNoZW4lMjBhZnRlciUyMGNsZWFuaW5nJTIwTmFwbGVzJTIwRmxvcmlkYXxlbnwwfHx8fDE3Nzk0NjU2MzJ8MA&ixlib=rb-4.1.0&q=70&w=1200",
  },
  {
    id: "airbnb",
    Icon: Key,
    title: "Airbnb & Vacation Rentals",
    link: "/services/airbnb-cleaning-naples-fl",
    description:
      "Fast turnovers, guest-ready every time. We help your property earn 5-star reviews consistently.",
    longDescription:
      "In the vacation rental business, cleanliness is your reputation. We specialize in fast, reliable turnovers between guests — same-day service available. Our team follows a hospitality-grade checklist: fresh linens, restocked essentials, staged spaces, and a photo-ready finish that keeps your reviews at 5 stars.",
    included: [
      "Same-day turnover service between guests",
      "Fresh linens, towel styling & bed staging",
      "Restocking essentials (toiletries, paper goods)",
      "Damage & inventory reporting after every clean",
      "Flexible scheduling synced to your booking calendar",
    ],
    image:
      "https://static.prod-images.emergentagent.com/jobs/22fc09d6-5993-494e-9284-a3e876c7697a/images/d9fee9c253d06add2975c505988a7530dec9fee6d3772d649a6111bd74f53d1f.png",
  },
  {
    id: "restaurants",
    Icon: Utensils,
    link: "/services/commercial-cleaning-naples-fl",
    title: "Restaurants",
    description:
      "After-hours cleaning that meets health code standards. Keep your kitchen spotless and guests safe.",
    longDescription:
      "A spotless restaurant protects your health inspection score and your brand. We work after hours so your operation never stops. Our team degreases kitchens, sanitizes prep surfaces, and details dining rooms to the standard your guests expect — meeting and exceeding Florida health code requirements.",
    included: [
      "After-hours & overnight scheduling",
      "Kitchen degreasing: hoods, equipment & prep areas",
      "Dining room, restroom & front-of-house detailing",
      "Floor care: sweeping, mopping & degreasing",
      "Health-code compliant sanitization protocols",
    ],
    image:
      "https://static.prod-images.emergentagent.com/jobs/22fc09d6-5993-494e-9284-a3e876c7697a/images/5c0a93695823e58feba7a8c8c059bebaa8d1c8ba4cf387adc93d66ce185586f9.png",
  },
  {
    id: "offices",
    Icon: Briefcase,
    link: "/services/commercial-cleaning-naples-fl",
    title: "Offices & Commercial",
    description:
      "Consistent, scheduled cleaning for your workplace. A clean office boosts productivity and morale.",
    longDescription:
      "First impressions matter — for your clients and your team. We provide consistent, scheduled commercial cleaning for offices, retail spaces, and professional buildings across Naples. Daily, weekly, or custom schedules, always with the same trusted crew and a quality checklist signed off on every visit.",
    included: [
      "Daily, weekly or custom cleaning schedules",
      "Workstations, conference rooms & common areas",
      "Restroom sanitization & supply restocking",
      "Trash removal, recycling & floor care",
      "Lobby & entryway detailing for client impressions",
    ],
    image:
      "https://static.prod-images.emergentagent.com/jobs/22fc09d6-5993-494e-9284-a3e876c7697a/images/e8f89d1afd0f19451b2215aed9426f5ca26915bf733f1db0c23dfa4d627e6bd9.png",
  },
  {
    id: "government",
    Icon: Flag,
    link: "/government-contracts",
    title: "Government & Municipal",
    description:
      "Reliable, contract-based cleaning that meets public sector standards for Naples' civic facilities.",
    longDescription:
      "Public facilities demand accountability, documentation, and consistency. Cindyrella Cleaning is licensed and insured for contract-based municipal work — from administrative offices to community centers. We deliver documented quality control and dependable staffing that public sector standards require.",
    included: [
      "Contract-based service with documented QC",
      "Administrative offices & public lobbies",
      "Community centers & civic facilities",
      "Restroom sanitization to public standards",
      "Licensed, insured & background-checked staff",
    ],
    image:
      "https://images.unsplash.com/photo-1641223693236-adc1c8f60102?crop=entropy&cs=srgb&fm=webp&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxnb3Zlcm5tZW50JTIwbXVuaWNpcGFsJTIwYnVpbGRpbmclMjBjbGVhbiUyMGxvYmJ5JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc1OTIxMjg1fDA&ixlib=rb-4.1.0&q=70&w=1200",
  },
];

export const TRUST_POINTS = [
  {
    Icon: CheckCircle,
    title: "Licensed & Fully Insured",
    description:
      "Complete peace of mind. We carry full liability insurance and all necessary licenses for every job.",
  },
  {
    Icon: Clock,
    title: "Always On Time",
    description:
      "We respect your schedule. Our team arrives on time, every time — because your time is valuable.",
  },
  {
    Icon: Search,
    title: "Detail-Oriented Cleaning",
    description:
      "We don't miss a spot. From ceiling corners to baseboards, our thoroughness sets us apart.",
  },
  {
    Icon: Key,
    title: "6+ years cleaning Airbnb & vacation rentals",
    description: "50+ rental owners served across Naples, Marco Island and Bonita Springs.",
  },
  {
    Icon: DollarSign,
    title: "Competitive Pricing",
    description:
      "Premium quality at fair rates. Transparent quotes with no hidden fees — ever.",
  },
];

export const GALLERY = [
  {
    type: "beforeAfter",
    before: "https://customer-assets-agu9un31.emergentagent.net/job_cindyrella-preview/artifacts/ps15erdf_IMG_7853.JPG.jpeg",
    after: "https://customer-assets-agu9un31.emergentagent.net/job_cindyrella-preview/artifacts/du9nyqur_WhatsApp%20Image%202026-01-28%20at%2011.48.46%20AM%20%281%29.jpeg",
    span: "col-span-2 row-span-2",
    label: "Kitchen Deep Clean",
    date: "Jan 25, 2025",
  },
  {
    url: "https://customer-assets-agu9un31.emergentagent.net/job_cindyrella-preview/artifacts/e846f2q8_IMG_0831%20-%20copia%20%282%29.webp",
    span: "",
    label: "Outdoor Lanai & Lighting Care",
    date: "Feb 2025",
  },
  {
    url: "https://images.unsplash.com/photo-1683629357846-30eacff8f615?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxzcG90bGVzcyUyMGx1eHVyeSUyMGtpdGNoZW4lMjBhZnRlciUyMGNsZWFuaW5nJTIwTmFwbGVzJTIwRmxvcmlkYXxlbnwwfHx8fDE3Nzk0NjU2MzJ8MA&ixlib=rb-4.1.0&q=70&w=1200",
    span: "",
    label: "Naples Luxury Kitchen",
    date: "Mar 2025",
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/22fc09d6-5993-494e-9284-a3e876c7697a/images/d9fee9c253d06add2975c505988a7530dec9fee6d3772d649a6111bd74f53d1f.png",
    span: "",
    label: "Airbnb Ready",
    date: "Apr 2025",
  },
  {
    url: "https://images.unsplash.com/photo-1583907659441-addbe699e921?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxjbGVhbmluZyUyMHByb2R1Y3RzfGVufDB8fHx8MTc3NTkyMDkyOXww&ixlib=rb-4.1.0&q=70&w=1200",
    span: "",
    label: "Pro Equipment",
    date: "May 2025",
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/22fc09d6-5993-494e-9284-a3e876c7697a/images/e8f89d1afd0f19451b2215aed9426f5ca26915bf733f1db0c23dfa4d627e6bd9.png",
    span: "",
    label: "Office Spaces",
    date: "Jun 2025",
  },
  {
    url: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=webp&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzc1OTIwOTI5fDA&ixlib=rb-4.1.0&q=70&w=1200",
    span: "",
    label: "Deep Clean",
    date: "Aug 2025",
  },
];

export const TESTIMONIALS = [
  {
    name: "Jimmy Suarez",
    location: "Naples, FL",
    role: "Google Review ★5.0",
    text: "They are very professional and efficient; they do excellent work and provide great service. I am very happy with their work and recommend them.",
  },
  {
    name: "Abundi LLC",
    location: "Naples, FL",
    role: "Google Review ★5.0",
    text: "Excellent service. They were punctual, detail-oriented, and left everything spotless. Very professional and reliable. Highly recommend.",
  },
  {
    name: "Tom Wilke",
    location: "Naples, FL",
    role: "Homeowner",
    text: "Cindy Rella Cleaning Company has always done a very nice job of cleaning my home in Naples. Nice people, and the owner is a class act. Would definitely recommend them to anyone needing cleaning service in the Naples area.",
  },
  {
    name: "Tess Rasmussen Skocik",
    location: "Naples, FL",
    role: "Real Estate Agent",
    text: "Cindyrella is the best!! Great job, really good price. My client's property needed a deep cleaning after the last renters moved out, and after Cindyrella came in — the same day I called them — the place feels clean, looks and smells wonderful. Now I can sell this house!",
  },
  {
    name: "Coco Ruiz",
    location: "Naples, FL",
    role: "Verified Client",
    text: "Very good service, punctuality and efficiency. I recommend it 100%. Muy buen servicio y puntualidad y eficiencia, lo recomiendo 100%.",
  },
];

export const SERVICE_OPTIONS = [
  "Residential Home Cleaning",
  "Airbnb & Vacation Rental",
  "Restaurant Cleaning",
  "Office & Commercial Space",
  "Government & Municipal",
  "Other",
];

export const REAL_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_cindyrella-preview/artifacts/a5jh0u2r_Video%20MPEG-4.mp4";
